import React, { useEffect, useState } from "react";
import timeZone from "../../../../../assets/images/timeZone.png";
import {
  GoogleMap,
  Marker,
  useJsApiLoader,
  Circle,
} from "@react-google-maps/api";
import useCrypto from "../../../../customHooks/crypto";
import { useSelector } from "react-redux";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";
import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";
import Typography from "@mui/material/Typography";
import { StyledEngineProvider } from "@mui/material/styles";
import {
  createLocationData,
  editLocationData,
} from "../../../AxiosRtk/Location";

const MAX = 5;
const MEDIUM = 3;
const MIN = 0;

const marks = [
  {
    value: MIN,
    label: "",
  },
  {
    value: MEDIUM,
    label: "",
  },
  {
    value: MAX,
    label: "",
  },
];


const initialValues = {
  latitude: "",
  deivce_id: "",
  longitude: "",
  geofence_address: "",
  zeofence_zone: "",
  type: 1,
  geofence_name: "",
  id: 0,
  enterNotificationSent: false,
  radius: MIN,
  exitNotificationSent: false,
};
const AddSafeZone = ({
  handleExit,
  isEdit,
  item = null,
  deviceSelected,
  addEditData,
  getLangTranslation
}) => {
  const { user } = useSelector(({ auth }) => auth);
  const { decryptRequest } = useCrypto();
  const { selectedKidId } = useSelector(
    ({ dashboard }) => dashboard
  );
  let [safeZoneData, setSafeZoneData] = useState({
    ...initialValues,
    deivce_id: deviceSelected,
  });

  const calculateRadiusInMetres = (val, type) => {
    return type == 1 ? val * 1000 : Math.floor(val * 1609.344);
  };

  useEffect(() => {
    if (isEdit) {
      console.log(item);
      setSafeZoneData({
        ...item,
        radius: item?.radius / 1000,
        radiusInMetres: calculateRadiusInMetres(
          item?.radius / 1000,
          item?.type
        ),
      });
    }
  }, []);

  const handleChange = (_, newValue) => {
    setSafeZoneData({
      ...safeZoneData,
      radius: newValue,
      radiusInMetres: calculateRadiusInMetres(newValue, safeZoneData.type),
    });
  };

  const handleChoose = (newValue) => {
    setSafeZoneData({ ...safeZoneData, radius: newValue });
  };

  const MAP_KEY = decryptRequest(process.env.REACT_APP_GOOGLE_MAP_KEY);

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: MAP_KEY,
    libraries: ["places"],
  });

  if (!isLoaded) {
    return "Loading";
  }

  const handleSave = () => {
    const payload = {
      deviceId: safeZoneData?.deivce_id,
      kidId: safeZoneData?.kidId || selectedKidId,
      IsSetGeofenceEnabled: 1,
      is_load_default_settings: 0,
      Geofence: [
        {
          GeofenceName: safeZoneData?.geofence_name,
          GeofenceZone: safeZoneData?.geofence_address,
          GeofenceAddress: safeZoneData?.geofence_address,
          Latitude: safeZoneData?.latitude,
          Longitude: safeZoneData?.longitude,
          Radius: safeZoneData?.radius * 1000,
        },
      ],
    };

    if (safeZoneData?.id) {
      payload.locationId = safeZoneData?.id;
    }
    if (isEdit) {
      editLocationData(payload)
        .then((res) => {
          if (res?.data?.status) {
            let payload = safeZoneData;
            delete payload.radiusInMetres;
            addEditData({
              ...payload,
              radius: payload?.radius * 1000,
            });
            handleExit();
          }
        })
        .catch((err) => {
          console.log("rating catch error ==>>", err?.response?.data?.message);
        });
    } else
      createLocationData(payload)
        .then((res) => {
          if (res?.data?.status) {
            let payload = safeZoneData;
            delete payload.radiusInMetres;
            addEditData({
              ...payload,
              id: res?.data?.result[0]?.safeZoneId,
              radius: payload?.radius * 1000,
            });
            handleExit();
          }
        })
        .catch((err) => {
          console.log("rating catch error ==>>", err?.response?.data?.message);
        });
  };

  return (
    <div className="row">
      <div className="col-md-6">
        <h5 className="text-uppercase text-gray mb-6">{getLangTranslation("SELECT_SAFE_ZONE_MAP", "Select safe zone on the map")}</h5>
        <div className="input-group mb-6">
          <span className="input-group-text border-end-0 fs-5 text-dark pe-0">
            <i className="icon-search"></i>
          </span>
          <PlacesAutocomplete
            value={safeZoneData?.geofence_address}
            onChange={(address) => {
              setSafeZoneData({
                ...safeZoneData,
                geofence_address: address,
                zeofence_zone: address,
              });
            }}
            onSelect={(address) => {
              geocodeByAddress(address)
                .then((results) => getLatLng(results[0]))
                .then((latLng) => {
                  setSafeZoneData({
                    ...safeZoneData,
                    latitude: latLng.lat,
                    longitude: latLng.lng,
                    geofence_address: address,
                    zeofence_zone: address,
                  });
                })
                .catch((error) => console.error("Error", error));
            }}
          >
            {({
              getInputProps,
              suggestions = { ...suggestions, types: ["geocode"] },
              getSuggestionItemProps,
              loading,
            }) => (
              <>
                <input
                  {...getInputProps({
                    placeholder: "Search Places ...",
                    className: "form-control border-start-0 flex-fill",
                  })}
                />
                <div className="autocomplete-dropdown-container w-100 ml-4">
                  {loading && <div>Loading...</div>}
                  {suggestions.map((suggestion) => {
                    const className = suggestion.active
                      ? "suggestion-item--active"
                      : "suggestion-item";
                    // inline style for demonstration purpose
                    const style = suggestion.active
                      ? { backgroundColor: "#fafafa", cursor: "pointer" }
                      : { backgroundColor: "#ffffff", cursor: "pointer" };
                    return (
                      <div
                        {...getSuggestionItemProps(suggestion, {
                          className,
                          style,
                        })}
                      >
                        <span>{suggestion.description}</span>
                      </div>
                    );
                  })}
                </div>
              </>
            )}
          </PlacesAutocomplete>
        </div>
        <div className="mb-6">
          <label htmlFor="zone" className="form-label">
            {getLangTranslation("SAFE_ZONE_NAME_TXT", "Safe zone name: ")}
          </label>
          <input
            type="text"
            className="form-control bg-white"
            placeholder="Enter safe zone name..."
            id="zone"
            value={safeZoneData?.geofence_name}
            onChange={(e) => {
              setSafeZoneData({
                ...safeZoneData,
                geofence_name: e.target.value,
              });
            }}
          />
        </div>
        <div className="mb-3">
          <label className="form-label text-uppercase text-gray">{getLangTranslation("SAFE_ZONE_NEW_RADIUS", "New radius")}</label>
          <div className="d-flex align-items-center gap-12">
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="radius"
                value={1}
                id="km"
                checked={safeZoneData?.type == 1 ? true : false}
                onChange={() => {
                  setSafeZoneData({
                    ...safeZoneData,
                    type: 1,
                    radiusInMetres: calculateRadiusInMetres(
                      safeZoneData.radius,
                      1
                    ),
                  });
                }}
              />
              <label className="form-check-label" htmlFor="km">
                {getLangTranslation("SAFE_ZONE_KM_TXT", "km")}
              </label>
            </div>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="radius"
                value={2}
                id="ml"
                checked={safeZoneData?.type == 2 ? true : false}
                onChange={() => {
                  setSafeZoneData({
                    ...safeZoneData,
                    type: 2,
                    radiusInMetres: calculateRadiusInMetres(
                      safeZoneData.radius,
                      2
                    ),
                  });
                }}
              />
              <label className="form-check-label" htmlFor="ml">
                {getLangTranslation("SAFE_ZONE_ML_TXT", "ml")}
              </label>
            </div>
          </div>
        </div>
        <StyledEngineProvider injectFirst>
          <Box sx={{}}>
            <Slider
              marks={marks}
              step={1}
              value={safeZoneData?.radius}
              valueLabelDisplay="auto"
              min={MIN}
              max={MAX}
              onChange={handleChange} className="custom-range-slider"
            />
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography
                variant="body2"
                onClick={() => handleChoose(MIN)}
                sx={{ cursor: "pointer" }}
              >
                {MIN} {safeZoneData?.type == 1 ? "km" : "ml"}
              </Typography>
              <Typography
                variant="body2"
                onClick={() => handleChoose(MEDIUM)}
                sx={{ cursor: "pointer" }}
              >
                {MEDIUM} {safeZoneData?.type == 1 ? "km" : "ml"}
              </Typography>
              <Typography
                variant="body2"
                onClick={() => handleChoose(MAX)}
                sx={{ cursor: "pointer" }}
              >
                {MAX} {safeZoneData?.type == 1 ? "km" : "ml"}
              </Typography>
            </Box>
          </Box>
        </StyledEngineProvider>

        <div className="row mt-4">
          <button className="btn btn-outline-primary col" onClick={handleExit}>
            <span className="btn-upper-case">{getLangTranslation("CANCEL", "Cancel")}</span>
          </button>
          <button className="btn btn-primary col ms-3" onClick={handleSave}>
            <span className="btn-upper-case">{getLangTranslation("SAVE", "Save")}</span>
          </button>
        </div>
      </div>
      <div className="col-md-6">
        <GoogleMap
          center={{
            lat: Number(safeZoneData?.latitude), // parent latitude
            lng: Number(safeZoneData?.longitude), // parent longitude
          }}
          zoom={11}
          mapContainerStyle={{ width: "100%", height: "100%" }}
          options={{
            zoomControl: false,
            streetViewControl: false,
            mapTypeControl: false,
            fullscreenControl: true,
          }}
        >
          <Marker
            position={{
              lat: Number(safeZoneData?.latitude), // parent latitude
              lng: Number(safeZoneData?.longitude), // parent longitude
            }}
            title={safeZoneData?.address}
          />

          <Circle
            center={{
              lat: Number(safeZoneData?.latitude), // parent latitude
              lng: Number(safeZoneData?.longitude), // parent longitude
            }}
            radius={safeZoneData?.radiusInMetres || 0} // in meters
            options={{
              strokeColor: "#FF0000",
              strokeOpacity: 0.8,
              strokeWeight: 2,
              fillColor: "#FF0000",
              fillOpacity: 0.35,
            }}
          />
        </GoogleMap>
      </div>
    </div>
  );
};

export default AddSafeZone;
